// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangesDoctorTemplate_wrapper__N10xe","section":"ChangesDoctorTemplate_section__UQqt9","image":"ChangesDoctorTemplate_image__-Nvkr"};